import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Row, Col,DatePicker,Space,Select,Divider, Tooltip,Collapse, Typography, Tag} from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css';
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import { AiFillDelete, AiFillEdit } from 'react-icons/ai'
import { IoMdCloseCircle } from 'react-icons/io';
import { toast, ToastContainer } from 'react-toastify';
import { Container, Image } from 'react-bootstrap';
import { FaRegCopy } from "react-icons/fa";
import { DownloadOutlined } from '@ant-design/icons';
import {QRCodeSVG} from 'qrcode.react';
import { FaArrowRightLong } from "react-icons/fa6";
import axios from 'axios';
import AddCharger from '../Chargers/AddCharger';
import AddLocation from './AddLocation';
import EditLocation from './EditLocation';
import LocationChargers from '../Chargers/LocationChargers';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';

import jsPDF from 'jspdf';
import ReactDOM from 'react-dom';
import {svg2pdf} from 'svg2pdf.js';

const Locations = ({ user, type,userGroups }) => {
    const [locations, setLocations] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isAddLocationModalVisible, setIsAddLocationModalVisible] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [isDeleteChargerModalVisible, setIsDeleteChargerModalVisible] = useState(false);
    const [locationToDelete, setLocationToDelete] = useState(null);
    const [chargerToDelete, setChargerToDelete] = useState(null);
    const [showQRCode, setShowQRCode] = useState({ show: false, codeId: '' });

    const [isDeleting, setIsDeleting] = useState(false);
    const [filterFromDate, setFilterFromDate] = useState(null);
    const [downtimeCsvDownloadData,setDowntimeCsvDownloadData] = useState({fromDate:null,toDate:null,locationInUseChargers:null,selectedChargers:[]})


    const [locationToEdit, setLocationToEdit] = useState(null);
    const [isEditLocationModalVisible, setIsEditLocationModalVisible] = useState(false);
    const [downloadFile,setDownloadFile] = useState(false);

    const [allLocations, setAllLocations] = useState([])

    const [isLoading, setIsLoading] = useState(true);
    const [isCSVLoading, setIsCSVLoading] = useState({sessionReport:false,downtimeReport:false})
    const [locationGroupIds, setLocationGroupIds] = useState([])
    const [isDownloadQrCodesLoading,setIsDownloadQrCodesLoading] = useState(false);
    const [filterLocationName, setFilterLocationName] = useState('');
    const [filterSubLocationType, setFilterSubLocationType] = useState(undefined);


    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
    });

    const [selectedLocation, setSelectedLocation] = useState(null)

    const [selectedLocationForChargers, setSelectedLocationForChargers] = useState(null)

    const [form] = Form.useForm();

    const { RangePicker } = DatePicker;

    const [manufacturerOptions,setManufacturerOptions] = useState([]);
    const [selectedManufacturers, setSelectedManufacturers] = useState([]);
    const [authorizedPermissions, setAuthorizedPermissions] = useState({});

    useEffect(() => {
        if (user) {
            getLocations();
            handleAdminAuthorizedPermissions();
        }

    }, [user]);

        const handleAdminAuthorizedPermissions =  () => {
        try {
            if(type === 'Breathe-Admin'){
                // console.log('Breathe Admin user ',userGroups);
                const allAuthorizedPermissions = {};
                userGroups.forEach((userGroup)=> Object.assign(allAuthorizedPermissions,JSON.parse(userGroup.permissions)));
                // setAuthorizedPermissions(JSON.parse(resultantUserGroup.permissions))
                setAuthorizedPermissions(allAuthorizedPermissions)
                // const resultantUserGroup = userGroups.find((userGroup)=>userGroup.groupName.includes('LocationAccessGroup'))
                // setAuthorizedPermissions(JSON.parse(resultantUserGroup.permissions))
           
            }
           
        } catch (error) {
            console.error('Error in handling Admin resources authorization',error);
            
        } 
    };

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getLocations(current, pageSize);
    };

    const getLocations = async (page = 1, limit = 10, nameFilter = filterLocationName, subLocationTypeFilter = filterSubLocationType) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getLocationList({
                page: page,
                limit: limit,
                filterLocationName: nameFilter,
                subLocationType: subLocationTypeFilter,
            });

            setLocations(res.data.locations);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getChargers = async (locationInUse)=>{
        try {
            // console.log('selected location: ',locationInUse);
            
            const res = await BreathAPIs.getChargerByLocation(locationInUse._id,new Date().toISOString());
            // setChargers(res);
            // options.clear();
           
            // console.log(res);
            setDowntimeCsvDownloadData((prev)=>{
                return { ...prev, locationInUseChargers:res.data.chargers}
            })
            let optionsSet = new Set();

            res.data.chargers.forEach((entry) => {
                const temp = entry.manufacturer.split('-');
                if (!optionsSet.has(entry.manufacturer)) {
                    optionsSet.add(entry.manufacturer);
                }
            });
       
            setManufacturerOptions(
                 Array.from(optionsSet).map((manufacturer) => {
                const label = manufacturer.split('-')[0];
                return { label: label, value: manufacturer };
            }))

        // console.log('options:',options);
        
            
        } catch (error) {
            console.log(error);
        }
    }


    const getAllLocations = async () => {
        try {
            const result = await BreathAPIs.getAllLocations();
            console.log("All loc data",result.data)
            setAllLocations(result.data)
        } catch (error) {
            console.log("Error in getting all locations", error.message)
        }
    }

   

    const handleCopyCode = () => {
        const codeToCopy = showQRCode.codeId;
        navigator.clipboard.writeText(codeToCopy);
    };

    function toLocalISOString(date) {
        const pad = (num) => String(num).padStart(2, '0');
    
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

    const jsonToCsv = (json,reportType) => {

        if(reportType === 'sessionReport'){

            const headers = Object.keys(json[0]);
            const csvRows = [];
        
           
            csvRows.push(headers.join(','));
        
      
            for (const row of json) {
                
              const values = headers.map(header => {
                // let value = row[header];
                // if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
                //     // Ensure it preserves the full format
                //     value = new Date(value).toISOString().replace('T', ' ').slice(0, 19);
                // }
                let escaped = ('' + row[header]).replace(/"/g, '\\"');
                return header === "Interval Data" ? `"${escaped.replace(/,/g,":")}"` : `${escaped}`;
              });
              csvRows.push(values.join(','));
            }
        
            return csvRows.join('\n');
        }
        if(reportType === 'downtimeReport'){
            

            let csvContent = "";
        
           
            csvContent += "ChargerID,OfflineTimestamp,DownTimeDuration,UpdatedBy,OnlineTimestamp\n";
        
            json.forEach((item) => {
                item.groupedDocuments.forEach((doc) => {
                    csvContent += `${doc.charger},${doc.offlineTimestamp},${doc.downTimeDuration},${doc.updatedBy},${doc.onlineTimestamp}\n`;
                });
            });
        
            // Add blank lines to separate the tables
            csvContent += "\n\n";
        
            // Add summary fields to the CSV
            csvContent += "Summary Fields\n";
            csvContent += "ChargerID,ChargerDowntimeCount,Downtime Duration (> 8 mins),Downtime Duration (5–8 Minutes),AverageDownTimeDuration,StandardDeviationDownTimeDuration\n";
        
            json.forEach((item) => {
                csvContent += `${item._id},${item.chargerDowntimeCount},${item.downtimeDurationRedWarning},${item.downtimeDurationYellowWarning},${item.averageDownTimeDuration},${item.standardDeviationDownTimeDuration}\n`;
            });

            return csvContent
        }
      };
    const callLambdaFunction = async () => {
        try {
            setIsCSVLoading({...isCSVLoading,sessionReport:true})

        // console.log('filterfromdate:',filterFromDate);
        const startDate = new Date(filterFromDate);
        // console.log("filterFromDate",filterFromDate)
        startDate.setDate(1);
        startDate.setHours(0,0,0,0);
     
        
        const tempendDate = new Date(filterFromDate.$y, filterFromDate.$M + 1 , 0).getDate();
        // console.log("tempendDate",tempendDate)
        const endDate = new Date(filterFromDate.$y,filterFromDate.$M,tempendDate);
        // console.log("endDate",endDate)
        endDate.setHours(23,59,59,999)
    
        
        // console.log('StartDate:',toLocalISOString(new Date(startDate)));
        // console.log('endDate:',toLocalISOString(new Date(endDate)));
        // console.log('Selected Location: ',selectedLocation._id);
        
        const result = await BreathAPIs.getLambdaData(toLocalISOString(new Date(startDate)),toLocalISOString(new Date(endDate)),selectedLocation._id,selectedManufacturers); 
        // console.log('Logging result',result);
                
        if(result.data && result.data.length === 0){
            toast.warn('No data to process in this time frame');
            setIsCSVLoading({...isCSVLoading,sessionReport:false})
            return;
        }
        if(result.status !== 200){
            toast.error('Error generating csv');
            setIsCSVLoading({...isCSVLoading,sessionReport:false})
            return;
        }
        const csvResponse = jsonToCsv(result.data,'sessionReport');
        // console.log(JSON.stringify(result.data))
        // const csvResponse = result.data;
        //   const jsonString = JSON.stringify(result, null, 2); 
        //   const blob = new Blob([csvResponse], { type: 'text/csv' }); 
      
          // Create a download link and trigger the download
        //   const link = document.createElement('a');
        //   link.href = URL.createObjectURL(blob);
        //   link.download = `BEVLocationReport${new Date().toISOString()}`
        //   document.body.appendChild(link); 
        //   link.click(); 
        //   document.body.removeChild(link); 
          const formattedDate = new Date().toISOString().split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$3-$2');
          const blob = new Blob([csvResponse], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('download', `${formattedDate}-${selectedLocation.locationName}-Commercial.csv`);
          a.click();
          setIsCSVLoading({...isCSVLoading,sessionReport:false})
      
        } catch (error) {
          console.error('Error calling AWS Lambda & report generation:', error);
          setIsCSVLoading({...isCSVLoading,sessionReport:false})
        }
      };
    
    const callDowntimeLambdaFunction = async () => {
        try {
            setIsCSVLoading({...isCSVLoading,downtimeReport:true})

        const tempStartDate = downtimeCsvDownloadData.fromDate;
        const startDate = new Date(tempStartDate.$y,tempStartDate.$M ,tempStartDate.$D,0,0,0);
        // console.log("startDate",startDate)
        
        const tempendDate = downtimeCsvDownloadData.toDate;
        // console.log("tempendDate",tempendDate)
        const endDate =new Date(tempendDate.$y,tempendDate.$M ,tempendDate.$D,23,59,59,999);
        // console.log("endDate",endDate)

        
        // console.log('StartDate:',toLocalISOString(new Date(startDate)));
        // console.log('endDate:',toLocalISOString(new Date(endDate)));
        const result = await BreathAPIs.getDowntimeLambdaData(toLocalISOString(new Date(startDate)),toLocalISOString(new Date(endDate)),downtimeCsvDownloadData.selectedChargers.length>0?downtimeCsvDownloadData.selectedChargers:downtimeCsvDownloadData.locationInUseChargers.map((charger)=>charger._id)); 
        // console.log('Downtime Data: ',JSON.stringify(result.data))
        if(result.data && result.data.length === 0){
            toast.warn('No data to process in this time frame');
            setIsCSVLoading({...isCSVLoading,downtimeReport:false})
            return;
        }
        if(result.status !== 200){
            toast.error('Error generating csv');
            setIsCSVLoading({...isCSVLoading,downtimeReport:false})
            return;
        }

        const csvResponse = jsonToCsv(result.data,'downtimeReport');

        const formattedDate = new Date().toISOString().split('T')[0].replace(/(\d{4})-(\d{2})-(\d{2})/, '$1-$3-$2');
          const blob = new Blob([csvResponse], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('download', `${formattedDate}-DowntimeData.csv`);
          a.click();
          // Clean up the URL object
          URL.revokeObjectURL(url);
          setIsCSVLoading({...isCSVLoading,sessionReport:false})

        } catch (error) {
          console.error('Error calling AWS Lambda & Report generation:', error);
          setIsCSVLoading({...isCSVLoading,downtimeReport:false})
        }
      };

      const disableFutureDates = (current) => {
        return current && current > new Date(); // Disable dates after today
      };

   
      

  
      

    // const handleDownloadImage = async () => {
    //     const imageUrl = `https://chart.googleapis.com/chart?cht=qr&chs=500x500&choe=UTF-8&chld=H&chl=${process.env.REACT_APP_BASE_URL}/registration/loc/${showQRCode.codeId}`;

    //     try {
    //         const response = await fetch(imageUrl, { method: 'GET', responseType: 'blob' });

    //         if (!response.ok) {
    //             throw new Error('Failed to fetch image');
    //         }

    //         const blob = await response.blob();
    //         const link = document.createElement('a');
    //         link.href = window.URL.createObjectURL(new Blob([blob]));
    //         link.download = `qr_code-${showQRCode.codeId}.png`;
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //     } catch (error) {
    //         console.error('Error downloading image:', error);
    //     }
    // };

    const downloadLocationCodeIDs = async (selectedLocationCodeId) => {
        try {
          setIsDownloadQrCodesLoading(true);

          const qrData = `${process.env.REACT_APP_BASE_URL}/registration/loc/${selectedLocationCodeId}`
      
          // Create a hidden container for rendering the QR code
          const container = document.createElement('div');
          container.style.position = 'absolute';
          container.style.left = '-9999px'; // Move off-screen
          document.body.appendChild(container);
      
    
          ReactDOM.render(
            <QRCodeSVG
              id="tempQrCodeSVG"
              value={qrData}
              size={190}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
            //   includeMargin={true}
              renderAs='svg'
            />,
            container,
            async () => {
              try {
                await new Promise((resolve) => setTimeout(resolve, 500));
      
               

                const svgElement = document.getElementById('tempQrCodeSVG');

                if (!svgElement) {
                  throw new Error('SVG element not found');
                }
      
                const pdfSize = 250;
                const margin = 30;
                const qrSize = pdfSize - 2 * margin;

                const pdf = new jsPDF({
                    format: [pdfSize, pdfSize]
                });

                await svg2pdf(svgElement, pdf, { x: margin, y: margin, width: qrSize, height: qrSize });
      
                // Save the PDF
                pdf.save(`qrcode-${selectedLocationCodeId}.pdf`);
              } finally {
                
                ReactDOM.unmountComponentAtNode(container);
                document.body.removeChild(container);
                setIsDownloadQrCodesLoading(false);
              }
            }
          );
        } catch (error) {
          console.error(error.message);
          setIsDownloadQrCodesLoading(false);
          toast.error('Something went wrong. Cannot download pdf for location code IDs');
        }
    };

    const handleBreatheAdminPermissions = (columns) => {

        if (JSON.parse(authorizedPermissions.upsertLocation || 'false')) {
            return columns
        }
        else {
            return columns.filter((column) => { return column.key !== 'addCharger' && column.key !== 'delete' })
        }
    }


    const columns = [
        {
            title: 'ID',
            dataIndex: '_id',
            key: '_id',
            render: (text, record) => (
                <Typography.Text
                    copyable={{ text: record._id }}
                    style={{ whiteSpace: 'nowrap' }}
                >
                    {record._id?.slice(-7)}...
                </Typography.Text>
            )
        },
        {
            title: 'Location Name',
            dataIndex: 'locationName',
            key: 'locationName',
            render: (text, record) => (
                <Button type='link'
                style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    maxWidth: '150px', 
                  }}
                onClick={() => { setSelectedLocationForChargers(record); }}>{record.locationName}</Button>
            )
        },
        {
            title: 'Operator Name',
            dataIndex: 'operatorName',
            key: 'operatorName'
        },
        {
            title: 'Active',
            dataIndex: 'active',
            key: 'active',
            render: (text, record) => (
                <Space direction="vertical" size={4}>
                    <Tag color={record.active ? 'green' : 'red'}>{record.active ? 'Active' : 'Inactive'}</Tag>
                    <Space size={4} wrap>
                        {record.locationType && <Tag color="blue">{record?.locationType}</Tag>}
                        {record.guestUserAccessible && <Tag color="gold">Guest Accessible</Tag>}
                        {record.locationType?.includes('SHARED') && <Tag color="purple">Shared</Tag>}
                    </Space>
                </Space>
            )
        },

        {
            title: 'Code ID',
            dataIndex: 'codeId',
            key: 'codeId',
            render: (text, record) => (
                <div className={styles['dynamicRatesDiv']}>
                <span className={styles['codeId']} onClick={() => { setShowQRCode({ codeId: record.codeId, show: true }); }}>
                    {record.codeId}
                </span>
                <span>
                    <Button
                        onClick={() => { downloadLocationCodeIDs(record.codeId) }}
                        style={{  boxShadow: 'none', border: 'none' }} icon={<DownloadOutlined />} />
                </span>
                        </div>
            )
        },
        {
            title: 'Redirect Code ID',
            dataIndex: 'redirectCodeId',
            key: 'redirectCodeId',
            render: (text, record) => (
                record.enableThirdPartyRedirect && record.redirectCodeId ? (
                    <div className={styles['dynamicRatesDiv']}>
                        <span className={styles['codeId']} onClick={() => { setShowQRCode({ codeId: record.redirectCodeId, show: true }); }}>
                            {record.redirectCodeId}
                        </span>
                        <span>
                            <Button
                                onClick={() => { downloadLocationCodeIDs(record.redirectCodeId) }}
                                style={{ boxShadow: 'none', border: 'none' }} icon={<DownloadOutlined />} />
                        </span>
                    </div>
                ) : '-'
            )
        },
        {
            title: 'Add Charger',
            key: 'addCharger',
            render: (text, record) => (
                <Button onClick={() => { setSelectedLocation(record); openModal(record); }}>Add Charger</Button>
            )
        },
      
        {
            title: 'Download Report',
            key:'downloadReport',
            render: (text, record) => (
                // <Button onClick={() => { setSelectedLocation(record); openModal(record); }}>Add Charger</Button>
                <Button type="primary" icon={<DownloadOutlined />} onClick={()=>{
                    setDownloadFile(true);setSelectedLocation(record);getChargers(record)
                    // setTimeout(() => {
                    //     getChargers();
                    // }, 1000);
                }} />
            )
        },
        {
            title: '',
            key: 'delete',
            width: 120,
            fixed: 'right',
            render: (text, record) => (
                <>
                   { 
                    
                    <Button type="Text" shape="circle" danger onClick={() => {showLocationEditModal(record); getAllLocations()}}>
                        <AiFillEdit />
                    </Button>}
                    {
                      type === 'Admin' ?
                        <Button className='ms-2' shape="circle" danger onClick={() => openDeleteModal(record)}>{<AiFillDelete></AiFillDelete>}</Button>
                       :
                       null
                    }
                </>
            )
        }
       
    ];

   

    const openDeleteModal = (location) => {
        setLocationToDelete(location);
        setIsDeleteModalVisible(true);
    };
    const handleDeleteChargerOk = async () => {
        if (chargerToDelete) {

        }
        setIsDeleteChargerModalVisible(false)
        setChargerToDelete(null);

    }
    const handleDeleteOk = async () => {
        if (locationToDelete) {
            try {
                if (locationToDelete) {
                    setIsDeleting(true);
                    await BreathAPIs.deleteLocation(locationToDelete._id);
                    setIsDeleting(false);
                    getLocations();
                    toast.success('Location deleted successfully.');
                }
            } catch (error) {
                console.error('Error deleting location:', error);
                setIsDeleting(false);
                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors.msg;
                    toast.error(errorMessage);
                } else {
                    toast.error('Error deleting location. Please try again later.');
                }
            } finally {
                setIsDeleteModalVisible(false);
                setLocationToDelete(null);
            }
        }

    };

    const handleDeleteCancel = () => {
        setIsDeleteModalVisible(false);
        setLocationToDelete(null);

        setIsDeleteChargerModalVisible(false)
        setChargerToDelete(null);
    };

    const openModal = (location) => {
        setCurrentLocation(location);
        setIsModalVisible(true);
    };

    const openAddLocationModal = () => {
        setIsAddLocationModalVisible(true);
    };


    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const handleAddLocationCancel = () => {
        setIsAddLocationModalVisible(false);
        form.resetFields();
    };

    const handleEditLocationCancel = () => {
        setIsEditLocationModalVisible(false);
        setLocationToEdit(null);
    };

    const showLocationEditModal = (location) => {
        setLocationToEdit(location);
        setIsEditLocationModalVisible(true); 
    };

    const handleSearchLocations = () => {
        getLocations(1, pagination.pageSize);
    };

    const handleClearLocationFilter = () => {
        setFilterLocationName('');
        setFilterSubLocationType(undefined);
        getLocations(1, pagination.pageSize, '', '');
    };

    const handleDownloadFileEnd = ()=>{
        setDownloadFile(false);
        setFilterFromDate(null);
        setIsCSVLoading({sessionReport:false,downtimeReport:false});
        // setSelectedLocation(null);
        setManufacturerOptions([]);
        setSelectedManufacturers([]);
        setDowntimeCsvDownloadData({fromDate:null,toDate:null,locationInUseChargers:null,selectedChargers:[]})
    }



    return (
        <Container>

            <ToastContainer></ToastContainer>

            {!selectedLocationForChargers &&
                <Form layout={'vertical'}>
                    <div className={styles['filter']}>
                        <div className={styles['filter-left']}>
                            <Input
                                value={filterLocationName}
                                placeholder='Search: Location Name'
                                onChange={(e) => setFilterLocationName(e.target.value)}
                                onPressEnter={handleSearchLocations}
                                allowClear
                            />
                            <Select
                                value={filterSubLocationType}
                                placeholder='Sub Location Type'
                                style={{ width: 180 }}
                                allowClear
                                onChange={(value) => setFilterSubLocationType(value)}
                                options={[
                                    { label: 'CONDO', value: 'CONDO' },
                                    { label: 'MULTI UNIT', value: 'MULTI_UNIT' },
                                ]}
                            />
                        </div>
                        <div className={styles['filter-right']}>
                            <Button onClick={handleSearchLocations} type="primary">Search</Button>
                            <Button onClick={handleClearLocationFilter} className={styles['custom-btn']} type="primary" danger shape="circle" icon={<IoMdCloseCircle />} />
                        </div>
                    </div>
                </Form>
            }

            <div className={styles.container}>
                {((JSON.parse(authorizedPermissions.upsertLocation || 'false') && (type==='Breathe-Admin')) || (type==='Admin')) 
                &&
                <Row justify="end" gutter={[16, 16]} className={styles.buttonRow}>
                    <Col>
                        <Button
                            type="danger"
                            onClick={openAddLocationModal}
                            className={styles.addLocationButton}
                        >
                            Add Location
                        </Button>
                    </Col>
                </Row>
                }
            </div>



            {selectedLocationForChargers ? 
                <div>
                    <div className={styles['breadcrumbs']}>
                        <div className={`${styles['breadcrumb']} ${styles['active']}`} onClick={()=>setSelectedLocationForChargers(null)}>Locations</div>
                        <div className={`${styles['breadcrumb']}`}><FaArrowRightLong /></div>
                        <div className={`${styles['breadcrumb']}`}>{selectedLocationForChargers?.locationName}</div>
                        <div className={`${styles['breadcrumb']}`}><FaArrowRightLong /></div>
                        <div className={`${styles['breadcrumb']}`}>Chargers</div>
                    </div>
                    <LocationChargers location={selectedLocationForChargers} />
                </div> 
            : 
                <Table
                    loading={isLoading}
                    dataSource={locations}
                    columns={( (type === 'Admin')) ?
                        
                            columns
                        :handleBreatheAdminPermissions(columns)}
                    rowKey="_id"
                    pagination={pagination}
                    onChange={handleTableChange}
                    className={styles['data-list']}
                    bordered
                    size="middle"
                    scroll={{ x: 'calc(600px + 50%)' }}
                />
            }



            <AddCharger
                location={selectedLocation}
                modalVisible={isModalVisible}
                closeModal={handleCancel}
                submitFeedback={(message) => { toast.success(message); }}
            />

            {locationToEdit && allLocations.length > 0 && <EditLocation
                modalVisible={isEditLocationModalVisible}
                closeModal={handleEditLocationCancel}
                selLocation={locationToEdit}
                submitFeedback={(message) => { toast.success(message); handleTableChange(pagination); }}
                allLocations={allLocations}
            />}

            <AddLocation
                modalVisible={isAddLocationModalVisible}
                closeModal={handleAddLocationCancel}
                submitFeedback={(message) => { toast.success(message); getLocations(); }}
            />

                <Modal
                title="Download File"
                open={downloadFile}
                onCancel={handleDownloadFileEnd}
                footer={null}
            >
                <Collapse accordion items={[
                                        {
                                            key: '1',
                                            label: <div style={{fontWeight:500}}>Session Report</div>,
                                            children:
                                            <div>
                                             <div className={styles['download-container']}> 
                                      
                            
                                                <Space direction="vertical" size={10} align='center'>

                                                    <DatePicker disabledDate={disableFutureDates} style={{width:170}} placeholder='Month From' onChange={(date) => setFilterFromDate(date)}  picker="month" value={filterFromDate}/>
                                                        </Space>
                                                        <Divider style={{borderColor:'#dbd7d7',height: 'auto'}} type = 'vertical' />
                                                        <Space  direction="vertical" size={10} align='center'>

                                                    <Select
                                                        mode="multiple"
                                                        allowClear
                                                        style={{ width: 170 }}
                                                        placeholder="Select Manufacturers"
                                                        value={selectedManufacturers}
                                                        onChange={(selectedValues) => setSelectedManufacturers(selectedValues)}
                                                        options={manufacturerOptions}
                                                        />
                                                    </Space>
                                                   
                                            
                                            </div>
                                                <div className={styles['download-button']}>
                                                    <ButtonCustom onClick={() => { callLambdaFunction() }} style={{height:'100%',width:'max-content',padding: 3.5 + 'px'}} text={"Generate Session Report"} disabled={isCSVLoading.sessionReport || filterFromDate === null} isLoading={isCSVLoading.sessionReport}></ButtonCustom>
                                                </div>

                                            </div>
                                        },
                                        {
                                            key: '2',
                                            label: <div style={{fontWeight:500}}>Downtime Report</div>,
                                            children: 
                                            <div>

                                            <div className={styles['download-container']}>
                                            
                              
                                            <Space direction="vertical" size={10} align='center'>
                                            <DatePicker style={{ width: 170 }} value={downtimeCsvDownloadData.fromDate} placeholder='Date From' onChange={(date) => setDowntimeCsvDownloadData({...downtimeCsvDownloadData,fromDate:date})} disabledDate={disableFutureDates}/>
                                            <DatePicker style={{ width: 170 }} value={downtimeCsvDownloadData.toDate} placeholder='Date To'  onChange={(date) => setDowntimeCsvDownloadData({...downtimeCsvDownloadData,toDate:date})}  disabledDate={(current) =>
                                                              current &&
                                                              (current > new Date() || (downtimeCsvDownloadData.fromDate && current < downtimeCsvDownloadData.fromDate))
                                                            }/>
                                            </Space>
                                            <Divider style={{borderColor:'#dbd7d7',height: 'auto'}} type = 'vertical' />
                                            <Space  direction="vertical" size={10} align='center'>
                                            <Select
                                                        mode="multiple"
                                                        allowClear
                                                        style={{ width: 170 }}
                                                        placeholder="Select Chargers"
                                                        value={downtimeCsvDownloadData.selectedChargers}
                                                        onChange={(selectedValues) => setDowntimeCsvDownloadData({...downtimeCsvDownloadData,selectedChargers:selectedValues})}
                                                        options={downtimeCsvDownloadData?.locationInUseChargers?.map((charger)=>{
                                                            return {  label:charger.chargerTag ,value:charger._id  }
                                                        })|| []}
                                                        />
                                            </Space>

                                         
                                          
                                            </div>
                                            <div className={styles['download-button']}>
                                                <ButtonCustom isLoading={isCSVLoading.downtimeReport} disabled={isCSVLoading.downtimeReport || downtimeCsvDownloadData.toDate === null || downtimeCsvDownloadData.fromDate === null} onClick={() => {callDowntimeLambdaFunction()}} style={{height:'100%',width:'max-content',padding: 3.5 + 'px'}} text={"Generate Downtime Report"} ></ButtonCustom>
                                            </div>
                                            
                                         </div>
                                        },
                                       
                                        ]} />
                             
            


            </Modal>


            <Modal
                title="Confirm Delete"
                visible={isDeleteModalVisible}
                onOk={handleDeleteOk}
                onCancel={handleDeleteCancel}
                confirmLoading={isDeleting}
            >
                <p>
                    Are you sure you want to delete the location with Operator Name:{" "}
                    {locationToDelete ? locationToDelete.operatorName : ""}?
                </p>
            </Modal>

            <Modal
                title="Register with location QR Code"
                visible={showQRCode.show}
                footer={null}
                onCancel={() => { setShowQRCode({ codeId: '', show: false }); }}
            >
                <div>
                    {/* {showQRCode.codeId && <Image width={'100%'} src={`https://chart.googleapis.com/chart?cht=qr&chs=500x500&choe=UTF-8&chld=H&chl=${process.env.REACT_APP_BASE_URL}/registration/loc/${showQRCode.codeId}`} />} */}
                    <div className='text-center mt-4'>
                        {/* <div><Button className='float-end' title='Download' onClick={handleDownloadImage}>Download</Button></div> */}
                        {showQRCode.codeId && <QRCodeSVG width={470} size={470} value={`${process.env.REACT_APP_BASE_URL}/registration/loc/${showQRCode.codeId}`} />}
                    </div>
                    <p className='text-center'>{showQRCode.codeId}<Button title='Copy' style={{ border: 'none' }} onClick={handleCopyCode}><FaRegCopy /></Button></p>
                </div>
            </Modal>

            <Modal
                title="Confirm Delete"
                visible={isDeleteChargerModalVisible}
                onOk={handleDeleteChargerOk}
                onCancel={handleDeleteCancel}
            >
                <p>
                    Are you sure you want to delete {" "}
                    {chargerToDelete ? chargerToDelete.chargerTag : ""}?
                </p>
            </Modal>
        </Container>
    );

};

Locations.propTypes = {
    user: PropTypes.string,
    type: PropTypes.string
};
const mapStateToProps = (state) => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null,
    userGroups : state.auth && state.auth.user ? state.auth.user.userGroups : null
});
export default connect(mapStateToProps, {})(Locations);
